import cn from 'classnames';
import styles from './NavTabItem.module.css';

type NavTabItemProps = {
  isActive: boolean;
  onClick: () => void;
  children: React.ReactNode;
};

export default function NavTabItem({ isActive, onClick, children }: NavTabItemProps) {
  return (
    <button className={cn(styles.button, isActive && styles.active)} onClick={onClick}>
      {children}
    </button>
  );
}
